module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/iphone-back-a1fc614700e92e5b9c8aff68648d877e.svg";